import { useEffect, useRef } from 'react';

export function useBoundaryReload(boundary, now, reload) {
  const reloadedFor = useRef(null);
  useEffect(() => {
    if (boundary !== null && boundary !== undefined && now >= boundary && reloadedFor.current !== boundary) {
      reloadedFor.current = boundary;
      reload();
    }
  }, [boundary, now, reload]);
}
